export const iconFontAwesomeChildhoodBabyCarriage = (
	<i className="fa-solid fa-baby-carriage"></i>
);
